export default {
    currEnv: 'prod',
    adminAccount: {
        TAWItech_SUPPORT: 'support@tawitech.ph'
    },
}